import { SebbiaIsotipo } from "@/components/brand/SebbiaLogo";
import { cn } from "@/lib/utils";
import { EJEMPLO } from "../content";

// Formato chileno de los mockups: `$756.686` y `$40.901,94`.
export const clp = (n) =>
  new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP", maximumFractionDigits: 0 }).format(n);
export const clp2 = (n) =>
  new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);

// Pill de estado: las variantes del design system (emerald=pagado, amber=pendiente, rose=atraso).
const TONOS = {
  pagado: "bg-emerald-500/10 text-emerald-700",
  pendiente: "bg-amber-500/10 text-amber-700",
  atraso: "bg-rose-500/10 text-rose-700",
  neutro: "bg-slate-500/10 text-slate-600",
  indigo: "bg-indigo-500/10 text-indigo-700",
};
export const Pill = ({ tono = "neutro", children, className }) => (
  <span className={cn("inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-[10px] font-semibold sm:text-[11px]", TONOS[tono], className)}>
    {children}
  </span>
);

// El chip de la UF, idéntico en intención al del header de la app: rótulo del día + valor.
export const ChipUF = ({ className }) => (
  <span
    className={cn(
      "inline-flex items-center gap-1.5 rounded-lg bg-white/10 px-2 py-1 text-[10px] font-semibold text-indigo-50 ring-1 ring-inset ring-white/15 sm:text-[11px]",
      className,
    )}
  >
    <span className="text-indigo-200">{EJEMPLO.ufLabel}</span>
    <span className="tabular-nums">{clp2(EJEMPLO.uf)}</span>
  </span>
);

// Recorte del AppShell real: la barra indigo-700 del header con el rayo y el chip UF. No es una
// ventana de sistema operativo (nada de tres puntos): es SEBBIA, recortada.
export const MarcoApp = ({ titulo, className, children }) => (
  <div
    className={cn("overflow-hidden rounded-2xl bg-slate-50 shadow-xl shadow-indigo-950/10 ring-1 ring-slate-900/5", className)}
    aria-hidden="true"
  >
    <div className="flex h-10 items-center justify-between gap-3 bg-indigo-700 px-3 sm:h-11 sm:px-4">
      <div className="flex min-w-0 items-center gap-2">
        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-lg bg-indigo-900">
          <SebbiaIsotipo className="h-[70%] text-gold-600" />
        </span>
        <span className="truncate text-[11px] font-semibold text-white sm:text-xs">{titulo}</span>
      </div>
      <ChipUF className="hidden sm:inline-flex" />
    </div>
    {children}
  </div>
);

// Rótulo honesto: las cifras de los mockups son inventadas y así lo dicen.
export const DatosEjemplo = ({ className }) => (
  <p className={cn("text-[10px] font-semibold uppercase tracking-widest text-slate-400", className)}>Datos de ejemplo</p>
);
